import axios from '@/service/request';
import type { R, BuyerOperationTypeEnum } from './types';


export interface CaptchaCheckRequest {
  /** 三方平台标识 */
  account: string;
  captcha: string;
  operationType: BuyerOperationTypeEnum.REGISTER;
}


/**
 * 三方免登(一次性ticket获取)
 */
export const apiCaptchaCheck = (data: CaptchaCheckRequest): Promise<R<boolean>> => {
  return axios.post('/buyer/captcha/check', data);
};

